import React from 'react';
import { Link } from 'react-router-dom';

import { Typography, Grid, Divider } from '@mui/material';

import { downloadImage } from 'js/library/services/StorageManager.js';
import placeholder from 'styles/assets/placeholder/placeholder.gif';
import { trackEventMatomoElementId } from 'js/library/utils/helpers';

export const Store = ({ data }) => {
  const [downloadedImage, setDownloadedImage] = React.useState(null);
  const id = data.id;

  function downloadImageOnLoad() {
    if (data.thumbnail !== undefined && downloadedImage === null) {
      const folder = data.type === 'product' ? data.thumbnail.split('/')[0] : 'promocao';
      const thumb = data.type === 'product' ? data.thumbnail.split('/')[1] : data.thumbnail;

      downloadImage(folder, thumb)
        .then((downloaded) => {
          setDownloadedImage(downloaded);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  return (
    <div key={id}>
      <Grid container spacing={3} style={{ width: '100%' }}>
        <Grid size={{ sm: 5, md: 5, lg: 5 }}>
          <Link
            onClick={() => trackEventMatomoElementId('ListaDePromocao', 'tocar', 'card', id)}
            to={{ pathname: '/oferta/', search: '?id=' + id, state: data }}
            style={{ textDecoration: 'none' }}
          >
            <img
              width="100%"
              alt="promo"
              onLoad={() => downloadImageOnLoad()}
              className="img-radius"
              src={downloadedImage === null ? placeholder : downloadedImage}
            />
          </Link>
        </Grid>
        <Grid size={{ sm: 5, md: 7, lg: 7 }}>
          <Link
            onClick={() => trackEventMatomoElementId('ListaDePromocao', 'tocar', 'card', id)}
            to={{ pathname: '/oferta/', search: '?id=' + id, state: data }}
            style={{ textDecoration: 'none', lineHeight: 1 }}
          >
            <Typography color="primary" variant="subtitle1">
              {data.establishmentName}
            </Typography>
            <Typography
              gutterBottom
              variant="h6"
              style={{ color: 'black', fontWeight: 'bolder', lineHeight: 1 }}
            >
              <i>{data.title}</i>
            </Typography>
            <Typography color="secondary" className="limit-text" variant="caption">
              {data.description}
            </Typography>
          </Link>
        </Grid>
      </Grid>

      <Divider style={{ margin: '20px 0px', float: 'right' }} width="80%" />
    </div>
  );
};

export default Store;
